import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";

import { LoadingSpinner } from "../../../components/LoadingSpinner";
import { IProduct } from "../../../models/catalogue";
import { isoProductUPC } from "../../../models/nominals";
import { ConfiguratorOptions } from "../ConfiguratorOptions";
import { getDefaultConfiguratorOptionSet } from "../utils";

type IProps = Immutable<{
    // Basic Data
    rootProduct: IProduct | null;

    // TODO(i18n): Ensure configType values are not user-facing. If they are displayed in UI, they need i18n.
    // Misc UI options
    configType: string;
}>;

const buildOptionSelectors = (): React.ReactNode => {
    const optionSet = getDefaultConfiguratorOptionSet();
    return (
        <ConfiguratorOptions
            disableQuantity={true}
            style={"mini"}
            optionSet={optionSet}
        />
    );
};

const buildConfiguratorContent = (
    rootProduct: IProduct | null,
): React.ReactNode => {
    if (!rootProduct) {
        return <LoadingSpinner />;
    }

    return <div>{buildOptionSelectors()}</div>;
};

const getRootClassNames = (configType: string): string => {
    return classNames({
        "configurator--mini": true,
        [`${configType}__configurator--mini`]: true,
    });
};

const getProductUPC = (rootProduct: IProduct | null): string => {
    return rootProduct && rootProduct.upc
        ? isoProductUPC.unwrap(rootProduct.upc)
        : "";
};

const getChildrenUPCs = (rootProduct: IProduct | null): string[] => {
    const children =
        rootProduct && rootProduct.children ? rootProduct.children : [];
    return children.map((c) => {
        return isoProductUPC.unwrap(c.upc);
    });
};

export const MiniConfigurator = ({
    rootProduct,
    configType,
}: IProps): React.ReactNode => {
    const configuratorClass = getRootClassNames(configType);
    const productUPC = getProductUPC(rootProduct);
    const childrenUPCJSON = JSON.stringify(getChildrenUPCs(rootProduct));
    return (
        <div
            className={configuratorClass}
            data-mpn={productUPC}
            data-children-mpns={childrenUPCJSON}
        >
            {buildConfiguratorContent(rootProduct)}
        </div>
    );
};
